import { render, staticRenderFns } from "./ModalEmailSendingConfirmation.vue?vue&type=template&id=6782e9a6&"
import script from "./ModalEmailSendingConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalEmailSendingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports